import { Injectable } from '@angular/core';
import { Subject, ReplaySubject, Observable } from 'rxjs';
import { MenuEnum } from '../model/nav-menu.model';

@Injectable({
  providedIn: 'root'
})
export class UserMenuManagementService {

  private _selectedMenu: Subject<MenuEnum> = new ReplaySubject<MenuEnum>();

  constructor() { }

  setSelectedMenu(menu: MenuEnum) {
    this._selectedMenu.next(menu);
  }

  getSelectedMenu(): Observable<MenuEnum> {
    return this._selectedMenu.asObservable();
  }
}
